import React, {Component} from "react";
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import { global } from './../../config.js';
import withRouter from './../withRouter';

import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css'

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Image from 'react-bootstrap/Image';
import Form from 'react-bootstrap/Form';

import ClipLoader from "react-spinners/ClipLoader";
import BarLoader from "react-spinners/BarLoader";

import Sortable from 'sortablejs';


class Audio extends Component {

    constructor(props) {
        super(props);
        this.state = {
            id: this.props.params.id,
            item: {},
            loading: true,
            error: false,
            show_modal_delete: false,
            audio: null,
            uploading: false,
            playlist: [],
            currentTrack: -1,
            autoPlay: false,
            playing: false,
            selectedFileId: 0,
            show_modal_edit: false,
            saving: false
        };

        this.item = this.item.bind(this)
        this.handleCloseDelete = this.handleCloseDelete.bind(this)
        this.delete = this.delete.bind(this)
        this.handleClickNext = this.handleClickNext.bind(this)
        this.handleClickPreviuos = this.handleClickPreviuos.bind(this)
        this.player = React.createRef();
        this.playAudio = this.playAudio.bind(this)
        this.createSort = this.createSort.bind(this)
        this.sort = this.sort.bind(this)
        this.handleCloseEdit = this.handleCloseEdit.bind(this)
        this.edit = this.edit.bind(this)
    }

    componentDidMount(){
        this.item()
    }

    createSort() {
        let self = this
        var el = document.getElementById('items');
        Sortable.create(el, {
            onEnd: function (evt) {
                self.sort()
            },
        });
    }

    sort() {
        let collection = document.getElementsByClassName('track');
        let elements = []

        for (let i = 0; i < collection.length; i++) {
            elements.push({id: parseInt(collection[i].getAttribute("data-id")), sort: i})
        }

        const requestOptions = {
            method: 'PUT',
            headers: { 
                'Authorization': 'Bearer ' + Cookies.get('session-acs'),
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*"
            },
            body: JSON.stringify(elements)
        };

        fetch(global.endpoint_api + '/items/' + this.state.id + '/audio/sort', requestOptions)
            .then(res => res.json().then(
            (result) => {
                if (res.status === 200 && !result.error) {
                    
                }
            },
            (error) => {}
        ))
    }



    item() {
        
        const requestOptions = {
            method: 'GET',
            headers: { 
                'Authorization': 'Bearer ' + Cookies.get('session-acs'),
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*"
            }
        };

        fetch(global.endpoint_api + '/items/' + this.state.id, requestOptions)
        .then(res => res.json().then(
            (result) => {

                if (res.status === 200 && !result.error) {
                    this.setState({
                        currentTrack: -1,
                        item: result,
                        loading: false,
                        audio: result.audio,
                        playlist: result.audio,
                        autoPlay: false
                    }, () => {
                        this.createSort()
                    });
                    
                } else {
                    if (result.error) {
                        this.setState({
                            error: result.error.message
                        });
                    } else {
                        this.setState({
                            error: "Произошла ошибка. Пожалуйста, попробуйте позже."
                        });
                    }
                }
                this.setState({
                    loading: false
                }, () => {
                    this.setState({
                        //autoPlay: true
                    })
                });
            }
        ))

    }


    delete() {

        this.setState({
            deleting: true,
            error: false
        })

        const requestOptions = {
            method: 'DELETE',
            headers: { 
                'Authorization': 'Bearer ' + Cookies.get('session-acs'),
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*"
            }
        };

        fetch(global.endpoint_api + '/items/' + this.state.id + "/audio/" + this.state.selectedFileId.id, requestOptions)
            .then(res => res.json().then(
            (result) => {
                if (res.status === 200 && !result.error) {
                    this.item()
                } else if (result.error) {
                    this.setState({
                        error: result.error.message
                    });
                } else {
                    this.setState({
                        error: "Неизвестная ошибка. Пожалуйста, попробуйте позже."
                    });
                }

                this.setState({
                    deleting: false,
                    show_modal_delete: false
                });
            },
            (error) => {}
        ))
    }


    handleCloseDelete() {
        this.setState({
            show_modal_delete: false
        })
    }

    handleCloseEdit() {
        this.setState({
            show_modal_edit: false
        })
    }

    handleFileChange = event => {
        let file = event.target.files[0]

        this.setState({
            uploading: true,
            error: false
        })

        const formData = new FormData();
        formData.append('file', file, file.filename);
        console.log(formData)
            
        fetch(global.endpoint_api + '/items/' + this.state.id + "/audio", {
          method: 'PUT',
          body: formData,
          headers: {
            'Authorization': 'Bearer ' + Cookies.get('session-acs'),
            "Access-Control-Allow-Origin": "*"
          },
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.Location) {
                let playlist = this.state.playlist
                playlist.push(data);
                this.setState({
                    uploading: false,
                    playlist
                });
                this.item()
            }
            else {
                this.setState({
                    uploading: false,
                    error: "Неизвестная ошибка. Пожалуйста, попробуйте позже."
                });
            }
          })
          .catch((err) => {
            console.error(err)
            this.setState({
                uploading: false,
                error: err
            });
          });
    };

    handleClickNext() {
        let currentTrack = this.state.currentTrack < this.state.playlist.length - 1 ? this.state.currentTrack + 1 : 0
        this.setState({
            currentTrack
        })
    }

    handleClickPreviuos() {
        let currentTrack = this.state.currentTrack > 0 ? this.state.currentTrack - 1 : this.state.playlist.length - 1
        this.setState({
            currentTrack
        })
    }

    playAudio = () => {
        if (!this.state.autoPlay)
            this.setState({autoPlay: true})
        document.getElementsByClassName("rhap_play-pause-button")[0].click()
    };

    edit() {

        this.setState({
            saving: true
        })

        const requestOptions = {
            method: 'PUT',
            headers: { 
                'Authorization': 'Bearer ' + Cookies.get('session-acs'),
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*"
            },
            body: JSON.stringify({ title: document.getElementById('title').value})
        };

        fetch(global.endpoint_api + '/items/' + this.state.id + '/audio/' + this.state.selectedFileId.id, requestOptions)
            .then(res => res.json().then(
            (result) => {
                if (res.status === 200 && !result.error) {
                    this.item()
                } else if (result.error) {
                    this.setState({
                        error: result.error.message
                    });
                } else {
                    this.setState({
                        error: "Неизвестная ошибка. Пожалуйста, попробуйте позже."
                    });
                }

                this.setState({
                    saving: false,
                    show_modal_edit: false
                });
            },
            (error) => {}
        ))
    }
    


    render() {

        let self = this
        let { item, loading, show_modal_delete, deleting, uploading, error, playlist, currentTrack, show_modal_edit, saving } = this.state

        return (
            <>
            <Row className="mb-4">
                <Col>
                    <Link to={"/items/" + this.state.id}>&larr; Назад</Link>
                </Col>
            </Row>
            <Row>
                <Col md={9} lg={6}>
                    <ClipLoader
                        loading={loading}
                        size={30}
                    />
                    {!item.title && !loading && (
                        <h4>Объект не найден или был удален</h4>
                    )}

                    {item.title && !loading && (
                        <>
                            <div className="mb-5">

                                <div className="card card-simple">
                                    <div className="card-body">
                                        <div className="">
                                            <h5><Image src="/images/icons/audio.svg" width={20}/> Аудио</h5>
                                            {playlist.length === 0 ? (
                                                <p className="small truncate-text-lines">Не добавлено</p>
                                            ) : (
                                                <AudioPlayer
                                                    ref={this.player}
                                                    src={playlist[this.state.currentTrack < 0 ? 0 : this.state.currentTrack].fileLocation}
                                                    showSkipControls
                                                    showJumpControls={false}
                                                    onPause={() => this.setState({playing: false})}
                                                    onPlay={e => {if (this.state.currentTrack < 0) this.setState({currentTrack: 0});this.setState({playing: true})}}
                                                    autoPlayAfterSrcChange={true}
                                                    className="mt-4"
                                                    onClickNext={this.handleClickNext}
                                                    onClickPrevious={this.handleClickPreviuos}
                                                    autoPlay={this.state.autoPlay}
                                                />
                                            )}
                                        </div>

                                        {playlist.length > 0 && (
                                            <div className="playlist" id="items">
                                                {Object.keys(playlist).map(function(key) {
                                                    return (
                                                        <div className={"track" + (parseInt(currentTrack) === parseInt(key) ? " playing" : "")} key={key} data-id={playlist[key].id} onClick={(e) => {if(["delete", "edit"].includes(e.target.name)) return;self.setState({currentTrack: parseInt(key)}, () => {if (!self.state.playing) self.playAudio()})}}>
                                                            
                                                            {/*
                                                            <div className="d-inline-block">
                                                                <div className="loader">
                                                                {parseInt(currentTrack) === parseInt(key) ? (
                                                                    <>
                                                                        {self.state.playing ? (
                                                                            <svg id="wave" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 38.05">
                                                                                <title></title>
                                                                                <path id="Line_1" data-name="Line 1" d="M0.91,15L0.78,15A1,1,0,0,0,0,16v6a1,1,0,1,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H0.91Z"/>
                                                                                <path id="Line_2" data-name="Line 2" d="M6.91,9L6.78,9A1,1,0,0,0,6,10V28a1,1,0,1,0,2,0s0,0,0,0V10A1,1,0,0,0,7,9H6.91Z"/>
                                                                                <path id="Line_3" data-name="Line 3" d="M12.91,0L12.78,0A1,1,0,0,0,12,1V37a1,1,0,1,0,2,0s0,0,0,0V1a1,1,0,0,0-1-1H12.91Z"/>
                                                                                <path id="Line_4" data-name="Line 4" d="M18.91,10l-0.12,0A1,1,0,0,0,18,11V27a1,1,0,1,0,2,0s0,0,0,0V11a1,1,0,0,0-1-1H18.91Z"/>
                                                                                <path id="Line_5" data-name="Line 5" d="M24.91,15l-0.12,0A1,1,0,0,0,24,16v6a1,1,0,0,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H24.91Z"/>
                                                                                <path id="Line_6" data-name="Line 6" d="M30.91,10l-0.12,0A1,1,0,0,0,30,11V27a1,1,0,1,0,2,0s0,0,0,0V11a1,1,0,0,0-1-1H30.91Z"/>
                                                                                <path id="Line_7" data-name="Line 7" d="M36.91,0L36.78,0A1,1,0,0,0,36,1V37a1,1,0,1,0,2,0s0,0,0,0V1a1,1,0,0,0-1-1H36.91Z"/>
                                                                                <path id="Line_8" data-name="Line 8" d="M42.91,9L42.78,9A1,1,0,0,0,42,10V28a1,1,0,1,0,2,0s0,0,0,0V10a1,1,0,0,0-1-1H42.91Z"/>
                                                                                <path id="Line_9" data-name="Line 9" d="M48.91,15l-0.12,0A1,1,0,0,0,48,16v6a1,1,0,1,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H48.91Z"/>
                                                                            </svg>
                                                                        ) : (
                                                                            <Image src="/images/icons/pause.svg" width={20} />
                                                                        )}
                                                                    </>
                                                                    
                                                                ) : (<Image src="/images/icons/play.svg" width={20} />)}
                                                                </div>
                                                            </div>
                                                            */}

                                                            {/*
                                                            <div className="d-inline-block play" onClick={(e) => {if(e.target.name === "delete") return;self.setState({currentTrack: parseInt(key)}, () => {if (!self.state.playing) self.playAudio()})}}>
                                                            {parseInt(currentTrack) === parseInt(key) ? <Image src="/images/icons/pause2.svg" width={20} name="play" /> : <Image src="/images/icons/play2.svg" width={20} name="play" />}
                                                            
                                                            </div>
                                                            */}
                                                            
                                                            <div className="d-inline-block track__name">
                                                                <p className="mb-0 text-truncate">{playlist[key].title}</p>
                                                            </div>
                                                            <div className="d-inline-block edit">
                                                                <Image src="/images/icons/edit.svg" width={20} name="edit" onClick={() => {self.setState({selectedFileId: playlist[key], show_modal_edit: true})}} />
                                                            </div>
                                                            <div className="d-inline-block delete">
                                                                <Image src="/images/icons/cancel.svg" width={20} name="delete" onClick={() => {self.setState({selectedFileId: playlist[key], show_modal_delete: true})}} />
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        )}
                                        

                                        <Row className="mb-4 justify-content-between">

                                            <Col>
                                                {!uploading && (
                                                    <>
                                                        <label className="btn btn-sm btn-dark" htmlFor="file-upload">
                                                            Загрузить {playlist.length > 0 && (<>ещё </>)}файл
                                                        </label>
                                                        <input
                                                            className="input-file"
                                                            type="file"
                                                            id="file-upload"
                                                            onChange={this.handleFileChange}
                                                            accept="audio/*"
                                                        />
                                                    </>
                                                )}
                                                 
                                                <BarLoader color="#0b2621" loading={uploading}/>
                                         
                                            </Col>
                                        </Row>
                                    
                                    </div>
                                </div>

                            </div>

                            {/*               
                            {audio != null && (
                                <Link to="#" className="text-danger"onClick={() => this.setState({show_modal_delete: true})}>Удалить аудио</Link>
                            )}
                            */}

                            <Modal show={show_modal_delete} onHide={this.handleCloseDelete} centered>
                                <Modal.Header closeButton>
                                    <Modal.Title>Удалить</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <p>Вы действительно хотите удалить аудио-файл<br />&laquo;{this.state.selectedFileId.title}&raquo;?</p>
                                </Modal.Body>
                                <Modal.Footer className="justify-content-between">
                                    <Button variant="light" disabled={deleting} onClick={this.handleCloseDelete}>
                                        Нет
                                    </Button>
                                    <Button variant="danger" disabled={deleting} onClick={this.delete}>
                                        Да
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            <Modal show={show_modal_edit} onHide={this.handleCloseEdit} centered>
                                <Modal.Header closeButton>
                                    <Modal.Title>Редактирование</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Form>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Название файла</Form.Label>
                                            <Form.Control type="text" id="title" defaultValue={this.state.selectedFileId.title} />
                                        </Form.Group>
                                    </Form>
                                </Modal.Body>
                                <Modal.Footer className="justify-content-between">
                                    <Button variant="light" disabled={saving} onClick={this.handleCloseEdit}>
                                        Отмена
                                    </Button>
                                    <Button variant="dark" disabled={saving} onClick={this.edit}>
                                        Сохранить
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                            
                        </>
                    )}

                    {error && (
                        <p className="text-danger">{error}</p>
                    )}
                    
                </Col>
            </Row>

            </>
        )

    }
}

export default withRouter(Audio);